import { Button, CheckboxField, IStyleConfig, mergeStyles, TextField, Tooltip, Preloader } from '@cian/components';
import * as React from 'react';

import { IJsonQuery } from '../../../../json_query';
import { validateEmailFormat } from '../../../../utils/format';
import { SubscriptionState, TSubscriptionState } from '../../../state';
import { listTracking, nothingFoundTracking } from './tracking';

const style = require('./index.css');

export interface ISubscribeProps {
  isNothingFound: boolean | undefined;
  isAuthenticated: boolean | undefined;
  group: number | undefined;
  subscriptionState: TSubscriptionState;
  jsonQuery: IJsonQuery;
  queryString: string;
  inputValue: string | undefined;
  onSubmit(email: string, isNews?: boolean, isExperiment?: boolean): void;

  description?: string;
  containerStyle?: IStyleConfig;
}

export interface ISubscribeState {
  inputValue: string;
  isInvalid: boolean;
  isNews: boolean;
}

const fakeEmailRex = /@social\.cian\.ru$/;

export class Subscribe extends React.Component<ISubscribeProps, ISubscribeState> {
  public constructor(props: ISubscribeProps) {
    super(props);

    this.state = {
      inputValue: props.inputValue && !fakeEmailRex.test(props.inputValue) ? props.inputValue : '',
      isInvalid: false,
      isNews: true,
    };
  }

  public componentDidMount() {
    if (this.props.subscriptionState !== SubscriptionState.Succeeded && this.props.isNothingFound) {
      nothingFoundTracking.trackShow(this.props.jsonQuery);
    }
  }

  public componentDidUpdate(prevProps: ISubscribeProps) {
    if (this.props.subscriptionState === SubscriptionState.Succeeded) {
      if (this.props.isNothingFound && this.state.isNews) {
        nothingFoundTracking.trackSubscribeWithNews();
      } else if (this.state.isNews) {
        listTracking.trackSubscribeWithNews();
      }
    }
  }

  public render() {
    const { subscriptionState } = this.props;

    return (
      <div {...mergeStyles(style['container'], this.props.containerStyle)}>
        {subscriptionState === SubscriptionState.Fetching && this.renderPreloader()}

        {this.getDescription()}

        {subscriptionState === SubscriptionState.Succeeded && this.renderSuccess()}

        {subscriptionState !== SubscriptionState.Succeeded && this.renderForm()}

        {subscriptionState === SubscriptionState.Failed && (
          <div className={style['fail']}>
            Во время отправки запроса произошла ошибка.
            <br />
            Попробуйте еще раз.
          </div>
        )}
      </div>
    );
  }

  private getDescription = () => {
    let description = 'Как только по этому запросу появятся объявления, мы отправим их вам на электронную почту';

    if (this.props.description === '') {
      return null;
    } else if (this.props.description) {
      description = this.props.description;
    }

    return <div className={style['description']}>{description}</div>;
  };

  private renderPreloader = () => (
    <div className={style['preloader']}>
      <Preloader preloaderStyle={style['preloader-circle']} size={36} />
    </div>
  );

  private renderForm = () => (
    <div>
      <Tooltip tooltipContent={this.getTooltipText()}>
        <TextField
          invalid={this.state.isInvalid}
          containerStyle={style['input']}
          placeholder="Ваш email"
          value={this.state.inputValue}
          onValueChange={this.handleValueChanged}
        />
      </Tooltip>
      <Button theme="button/solid" onClick={this.handleSubmitClicked}>
        Подписаться
      </Button>
      {this.props.isNothingFound && this.renderNewsCheckbox()}
      {!this.props.isAuthenticated ? Subscribe.renderLicence() : null}
    </div>
  );

  private renderNewsCheckbox = () => {
    return (
      <CheckboxField
        containerStyle={style['news-checkbox']}
        value={this.state.isNews}
        onValueChange={this.handleChangeNewsCheckbox}
        label="Хочу получать новости Cian.ru"
      />
    );
  };

  private handleChangeNewsCheckbox = () => {
    this.setState({
      isNews: !this.state.isNews,
    });
  };

  private static renderLicence() {
    return (
      <div className={style['licence']}>
        <span>При подписке вы принимаете условия </span>
        <a target="_blank" className={style['licence-link']} href="//www.cian.ru/help/about/rules/">
          Пользовательского соглашения
        </a>
        <br /> и{' '}
        <a target="_blank" className={style['licence-link']} href="//www.cian.ru/help/about/36526/">
          Политики конфиденциальности
        </a>
      </div>
    );
  }

  private renderSuccess = () => (
    <div className={style['success']}>
      <div className={style['success-image']} />
      <div>
        На <b>{this.state.inputValue}</b> отправлено письмо для активации подписки
      </div>
    </div>
  );

  private getTooltipText = () => (this.state.isInvalid ? 'Вы ввели некорректный email' : '');

  private handleValueChanged = (value: string) =>
    this.setState({
      inputValue: value,
      isInvalid: false,
    });

  private handleSubmitClicked = () => {
    const val = this.state.inputValue;
    const isValid = validateEmailFormat(val);

    this.setState({ isInvalid: !isValid });

    if (!isValid) {
      return;
    }

    this.props.onSubmit(val, this.state.isNews);
  };
}
